module.exports = __webpack_public_path__ + "img/phone_h5.db8d8471.png";